(function () {
  'use strict';

  var STORAGE_KEY = 'ua_private_edit_attribution';
  var MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;
  var params = new URLSearchParams(window.location.search);
  var session = clean(params.get('private_edit_session'), 80);
  var attribution = readStored();

  if (session) {
    attribution = {
      session: session,
      gender: clean(params.get('private_edit_gender'), 20),
      presence: clean(params.get('private_edit_presence'), 30),
      occasion: clean(params.get('private_edit_occasion'), 30),
      focus: clean(params.get('private_edit_focus'), 30),
      content: clean(params.get('utm_content'), 80),
      capturedAt: Date.now()
    };
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(attribution)); } catch (error) {}
  }

  if (!attribution || !attribution.session) return;

  function clean(value, max) {
    return typeof value === 'string' ? value.trim().slice(0, max) : '';
  }

  function readStored() {
    try {
      var value = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (!value || !value.session || Date.now() - Number(value.capturedAt || 0) > MAX_AGE_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return value;
    } catch (error) {
      return null;
    }
  }

  function profile() {
    return [attribution.gender, attribution.presence, attribution.occasion, attribution.focus].filter(Boolean).join(' · ');
  }

  function publish(name, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, data));
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('un_atelier:' + name, data);
      }
    } catch (error) {}
  }

  function attachCartAttributes() {
    var attributes = {
      'Private Edit Session__': attribution.session,
      'Private Edit Profile__': profile(),
      'Private Edit Entry__': attribution.content || 'direct'
    };
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
      credentials: 'same-origin',
      keepalive: true
    }).then(function (response) {
      if (response.ok) publish('private_edit_cart_attributed', { session: attribution.session, profile: profile() });
    }).catch(function () {});
  }

  function upsertHidden(form, name, value) {
    if (!value) return;
    var input = form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function decorateProductForms(root) {
    (root || document).querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      upsertHidden(form, 'properties[_Private Edit Session]', attribution.session);
      upsertHidden(form, 'properties[_Private Edit Profile]', profile());
      upsertHidden(form, 'properties[_Private Edit Entry]', attribution.content || 'direct');
    });
  }

  decorateProductForms(document);
  attachCartAttributes();
  publish('private_edit_store_arrival', { session: attribution.session, profile: profile(), entry: attribution.content || 'direct' });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    decorateProductForms(form.parentNode || document);
    publish('private_edit_add_to_cart_intent', { session: attribution.session, profile: profile() });
    attachCartAttributes();
  }, true);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) decorateProductForms(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
